import LogoSvg from "features/assets/logo.svg";

const Logo = (props) => {
  const { className } = props;
  return <img className={`p-0.5 ${className}`} src={LogoSvg} alt="Sigorta Logo" />;
};

export default Logo;
